export default ($interval) => ({
    scope: false,
    restrict: 'EA',
    link(scope, element, attr) {
        let iteration = 0;
        const kids = element.children();
        let doit = () => {
            kids.each((i, c) => c.style.display = ((iteration % kids.length) === i) ? 'inline' : 'none');
            iteration++;
        }
        $interval(doit, attr.interval || 3500);
        doit();
    }
});